import { ChartLineStyle } from '../../../colorSelector/lineStyle.types'

export const CP_DEFAULT_PRICE_LINE_COLOR = '#9C27B0'
export const CP_DEFAULT_NECK_LINE_COLOR = '#9C27B0'
export const CP_DEFAULT_BACKGROUND_COLOR = '#9C27B033'
export const CP_DEFAULT_PANE_LABEL_COLOR = '#9C27B0'
export const CP_DEFAULT_PANE_LABEL_TEXT_COLOR = '#FFFFFF'
export const CP_DEFAULT_PRICE_LINE_WIDTH = 2
export const CP_DEFAULT_NECK_LINE_WIDTH = 2

export const CHART_PATTERN_LINE_STYLE_OPTIONS: { label: string; value: ChartLineStyle }[] = [
    { label: 'Solid', value: 'solid' },
    { label: 'Dotted', value: 'dotted' },
    { label: 'Dashed', value: 'dashed' },
    { label: 'Large Dashed', value: 'largeDashed' },
    { label: 'Sparse Dotted', value: 'sparseDotted' },
]

/** TradingView-style candlestick pattern marker colors */
export const CP_CANDLESTICK_MARKER_COLOR = '#2962FF'
export const CP_CANDLESTICK_BEARISH_MARKER_COLOR = '#F23645'
export const CP_CANDLESTICK_CANDLE_FILL_OPACITY = 0.08

export const chartLineStyleToLineType = (style: string | undefined) => {
    switch (style) {
        case 'dotted': return 'dotted' as const
        case 'dashed':
        case 'largeDashed':
        case 'sparseDotted': return 'dashed' as const
        default: return 'normal' as const
    }
}

const toBool = (value: unknown, fallback: boolean): boolean => {
    if (value === true || value === 'true') return true
    if (value === false || value === 'false') return false
    return fallback
}

export const resolveChartPatternOverlaySettings = (raw: Record<string, unknown> | undefined) => {
    const nested = (raw as { settings?: Record<string, unknown> })?.settings ?? raw ?? {}
    return {
        priceLineColor: (nested.priceLineColor ?? nested.lineColor ?? CP_DEFAULT_PRICE_LINE_COLOR) as string,
        priceLineStyle: (nested.priceLineStyle ?? 'solid') as string,
        priceLineWidth: Number(nested.priceLineWidth ?? nested.lineWidth ?? CP_DEFAULT_PRICE_LINE_WIDTH),
        neckLineColor: (nested.neckLineColor ?? nested.lineColor ?? CP_DEFAULT_NECK_LINE_COLOR) as string,
        neckLineStyle: (nested.neckLineStyle ?? 'dotted') as string,
        neckLineWidth: Number(nested.neckLineWidth ?? nested.lineWidth ?? CP_DEFAULT_NECK_LINE_WIDTH),
        showBackground: toBool(nested.showBackground ?? nested.showLineFills, true),
        backgroundColor: (nested.backgroundColor ?? nested.fillColor ?? CP_DEFAULT_BACKGROUND_COLOR) as string,
        showPaneLabels: toBool(nested.showPaneLabels ?? nested.showLabels, true),
        paneLabelColor: (nested.paneLabelColor ?? CP_DEFAULT_PANE_LABEL_COLOR) as string,
        paneLabelTextColor: (nested.paneLabelTextColor ?? CP_DEFAULT_PANE_LABEL_TEXT_COLOR) as string,
        showLines: toBool(nested.showLines ?? nested.showTrendlines, true),
        showPolylines: toBool(nested.showPolylines ?? nested.showPatternLines, true),
        showTrendlines: toBool(nested.showTrendlines ?? nested.showLines, true),
        showPatternLines: toBool(nested.showPatternLines ?? nested.showPolylines, true),
        showPriceTarget: toBool(nested.showPriceTarget, true),
        labelColorBullish: (nested.labelColorBullish ?? nested.paneLabelColor ?? CP_CANDLESTICK_MARKER_COLOR) as string,
        labelColorBearish: (nested.labelColorBearish ?? CP_CANDLESTICK_BEARISH_MARKER_COLOR) as string,
        candleFillOpacity: Number(nested.candleFillOpacity ?? CP_CANDLESTICK_CANDLE_FILL_OPACITY),
    }
}
